import { useState, useEffect } from "react";

const LOGO_URL =
  "https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/050a4db70d65b968b005ddd7348aeef2.png";
const WHATSAPP_LINK = "https://wa.me/557183822916";

const navLinks = [
  { label: "Início", href: "#inicio" },
  { label: "Escritório", href: "#escritorio" },
  { label: "Atuação", href: "#atuacao" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Contato", href: "#contato" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-petrol-dark shadow-sm py-3"
          : "bg-petrol-dark py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#inicio"
          onClick={(e) => { e.preventDefault(); handleNavClick("#inicio"); }}
          className="flex items-center cursor-pointer"
        >
          <img
            src={LOGO_URL}
            alt="Georges Humbert Advocacia"
            className="h-[77px] w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer whitespace-nowrap text-white/90 hover:text-gold-light"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* CTA Button */}
        <div className="hidden lg:flex items-center gap-3">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center gap-2 bg-gold-light hover:bg-gold-medium text-petrol-darkest text-sm font-semibold px-5 py-2.5 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-whatsapp-line text-base" />
            </span>
            Falar no WhatsApp
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer text-white"
        >
          <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`} />
        </button>
      </div>

      {/* Mobile Dropdown */}
      {menuOpen && (
        <div className="lg:hidden bg-petrol-dark border-t border-white/10 px-6 py-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="block text-white/90 hover:text-gold-light text-sm font-medium py-3 border-b border-white/10 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-gold-light text-petrol-darkest text-sm font-semibold px-5 py-3 rounded-md mt-4 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-base" />
            Falar no WhatsApp
          </a>
        </div>
      )}
    </header>
  );
}
